import { canUseDOM } from 'exenv';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import set from 'lodash/set';
import toNumber from 'lodash/toNumber';
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import Insert from '../../../components/post/content/insert';
import throttle from 'lodash/throttle';
import Cookies from 'js-cookie';
import Ad from '../../../components/ad/ad';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';
import { isAdvertorial } from '../../../../views/components/advertorial/advertorial';
import PostsContainer from '../../../components/post/container';
import MoreStories from '../../../components/more-stories-component/more-stories-component';
import VideoModule from '../../../components/video_module/video_module';
import ToasterVideoModule from '../../../components/toaster_video_module/toaster_video_module';
import FloatingPlayer from '../../../components/floating_player/floating_player';

import Dianomi from '../../../components/dianomi/dianomi';

import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import trackThirdPartyJS from '../../../../client/utils/third_party_trackers/trackThirdPartyJS';
import adsConfig from '../../../../config/ads';
import { buildPostAdModel } from '../../../../utils/ad_util';
import matchMediaDesktop from '../../../../utils/client_util';
import { findAdvertorialTagID } from '../../../../utils/advertorial_utils';
import { infiniteScrollUrlChange } from '../../../../redux/action_creators/post/postpage_action_creators';
import asyncPostFiniteActions from '../../../../redux/actions/post/async_post_finite_actions';
import asyncPostNativeAdActions from '../../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../../redux/action_creators/ads_action_creator';

let scriptjs = false;

if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
}

class PostPage extends Component {
  constructor(props) {
    super(props);
    const { live } = props.post;

    this.finiteScrollDepth = null;
    this.calledNativePixel = false;
    this.renderedNativeInfiniteScrollPost = false;
    this.setScrollEvents = throttle(() => {
      const { scrollY, innerHeight } = this.window;
      this.setFiniteScrollDepth(scrollY, innerHeight);
      this.setInviewPostUrl(scrollY, innerHeight);
    }, 100);
    this.generateAdData = this.generateAdData.bind(this);
    this.state = {
      finitePosts: [],
      stickToasterVideo: false,
      ignoreToasterVideo: false,
      displayingAdhesiveUnit: true,
      activeInserts: {}
    };
    this.playerScriptIds = [
      'QV73eWiB',
      '4h5SWQPt',
      'Pafg29um',
      '27mBLzWL',
      'i70nsZ8K',
      'Lrp0YsKC',
      'wGNMZweZ',
      'kMmGs8qw',
      'WXJihrBk',
      'iqio3VCM',
      'OolwHeKf',
      'FsIzKJce',
      'r04h3Jdn',
      'RvGXj7in',
      'flarUGPa',
      'HzdTLaau',
      'gAy6i1bi',
      'RqEFED7X',
      'vp2iCnvh',
      'b2BPV4nc'
    ];
    this.live = get(live, 'enabled', false) && !!get(live, 'posts.length', 0);
  }

  componentDidMount() {
    const { statusCode, config, post } = this.props;

    this.window = window;
    this.body = document.body;
    this.activePost = get(post, 'id') || get(this.props, 'match.params.id');
    this.lazyThresholdFromBottom = 400;
    this.stickySidebar = matchMediaDesktop();
    this.trackedPosts = [];

    this.setActiveSocial();
    this.refreshSocialEmbeds();

    if (!this.live) {
      this.window.addEventListener('scroll', this.setScrollEvents);
    }

    if (statusCode !== 404 && statusCode !== 403 && statusCode !== 500) {
      const postId = get(this.props, 'match.params.id');
      const advertorialTag = findAdvertorialTagID(get(post, 'tags'));

      this.props.dispatchPostFinite(postId, advertorialTag, config);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (isAdvertorial(get(nextProps, 'post.tags'))) {
      return;
    }

    // Check to see if the ad call has been made for mid article injection unit
    const nativeAdMidArticleInjectLoaded = get(
      nextProps,
      'adsLoaded.native_mid_article_inject'
    );

    // Check to see if the ad call has been made for dianomi/sponsor tile unit
    const nativeAdSponsorTileLoaded = get(
      nextProps,
      'adsLoaded.native_sponsoredtile'
    );

    // Check to see if the ad call has been made for recommendation unit
    const nativeAdRecommendationLoaded = get(
      nextProps,
      'adsLoaded.native_recommendationlink'
    );

    // Check to see if the ad call has been made for inf scroll injection unit
    const nativeAdInfiniteScrollLoaded = get(
      nextProps,
      'adsLoaded.native_infinitescroll'
    );

    // Logic, when adcall is made, call out func to fetch posts for that, then set adcalled to false so it doesn't create inf loop
    if (nativeAdMidArticleInjectLoaded) {
      this.getNative('nativeMidArticleInject');
      this.props.dispatchAdLoadedEvent('native_mid_article_inject', false);
    }

    if (nativeAdRecommendationLoaded) {
      this.getNative('nativeAdRecommendation');
      this.props.dispatchAdLoadedEvent('native_recommendationlink', false);
    }

    if (nativeAdSponsorTileLoaded) {
      this.getNative('nativeAdSponsorTile');
      this.props.dispatchAdLoadedEvent('native_sponsoredtile', false);
    }

    if (nativeAdInfiniteScrollLoaded) {
      setTimeout(() => {
        this.getNative('nativeAdInfiniteScroll');
        this.props.dispatchAdLoadedEvent('native_infinitescroll', false);
      }, 0);
    }
  }

  componentDidUpdate() {
    const live = get(this.props, 'post.live');
    this.live = get(live, 'enabled', false) && !!get(live, 'posts.length', 0);
    this.refreshSocialEmbeds();
    this.posts = this.getPostElements();
  }

  componentWillUnmount() {
    if (!this.live) {
      this.window.removeEventListener('scroll', this.setScrollEvents);
    }
  }

  getPostElements() {
    return document.querySelectorAll('.post__body');
  }

  setActiveSocial(post) {
    const activeClass = 'social--active';
    const activeSocial = document.querySelector(`.${activeClass}`);

    if (activeSocial) {
      activeSocial.classList.remove(activeClass);
    }

    const activePost = post || document.querySelector('.post__wrapper');
    if (activePost) {
      activePost.querySelector('.social').classList.add(activeClass);
    }
  }

  setFiniteScrollDepth(windowPosition, screenHeight) {
    const { postFinite, config, post } = this.props;
    const RECIRC_OFFSET = 300;
    const bottomOfScreen = windowPosition + screenHeight;
    const recircPosition = document.querySelector('.recirc').offsetTop;
    const triggerPoint = recircPosition - RECIRC_OFFSET;

    // Trigger toaster video
    if (
      get(config, 'featureFlags.toasterVideo') &&
      bottomOfScreen >= 1000 &&
      !this.state.ignoreToasterVideo
    ) {
      this.setState({
        stickToasterVideo: true
      });
    }
    if (triggerPoint < bottomOfScreen && get(postFinite, 'length')) {
      if (
        !this.renderedNativeInfiniteScrollPost &&
        get(this.props, 'nativeInfiniteScrollPost.length') &&
        !isAdvertorial(get(post, 'tags'))
      ) {
        this.setState(
          {
            finitePosts: [
              ...this.state.finitePosts,
              get(this.props, 'nativeInfiniteScrollPost[0]')
            ]
          },
          () => {
            this.renderedNativeInfiniteScrollPost = true;
          }
        );
      }
      this.setState({
        finitePosts: [...this.state.finitePosts, postFinite.shift()]
      });
    }
  }

  getNative(nativeType) {
    if (nativeType === 'nativeMidArticleInject') {
      const nativeAdsDataMidArticleInject = get(
        window,
        'fc_ads.native.midArticleInject'
      );

      if (nativeAdsDataMidArticleInject) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataMidArticleInject,
          get(this.props, 'config')
        );
      }
    }

    if (nativeType === 'nativeAdSponsorTile') {
      const nativeAdsDataDianomi = get(window, 'fc_ads.native.dianomiTiles');

      if (nativeAdsDataDianomi) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataDianomi,
          get(this.props, 'config')
        );
      }
    }

    if (nativeType === 'nativeAdRecommendation') {
      const nativeAdsDataRecommendations = get(
        window,
        'fc_ads.native.recommendations'
      );

      if (nativeAdsDataRecommendations) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataRecommendations,
          get(this.props, 'config')
        );
      }
    }

    if (nativeType === 'nativeAdInfiniteScroll') {
      const nativeAdsDataInfiniteScroll = get(
        window,
        'fc_ads.native.infiniteScroll'
      );

      if (nativeAdsDataInfiniteScroll) {
        this.props.dispatchPostNativeAd(
          nativeAdsDataInfiniteScroll,
          get(this.props, 'config')
        );
      }
    }

    return false;
  }

  setActive(postID) {
    this.state.activeInserts[postID] = 1;
    this.forceUpdate();
  }

  setInviewPostUrl(windowPosition, screenHeight) {
    if (!this.posts || !get(this.posts, 'length')) {
      return false;
    }

    const triggerPoint = windowPosition + screenHeight / 2;
    for (let i = 1; i <= get(this.posts, 'length'); i += 1) {
      const post = this.posts[i - 1];
      const sectionTopPosition = post.offsetTop;
      const sectionBottomPosition = sectionTopPosition + post.clientHeight;
      const postId = parseFloat(post.dataset.id);

      if (
        this.activePost !== postId &&
        sectionTopPosition <= triggerPoint &&
        sectionBottomPosition > triggerPoint
      ) {
        this.activePost = postId;
        // const postData = post.dataset;
        const postData =
          i === 1 ? this.props.post : this.state.finitePosts[i - 2];

        // React router redux does not support replace state without page refresh.
        this.props.dispatchInfiniteScrollUrlChange();
        let replacedURL = `/${postData.id}/${postData.slug}`;

        if (get(postData, 'isVideoPermalink')) {
          replacedURL = `/video/${postData.slug}/${get(
            postData,
            'posterVideo.feedId'
          )}`;
        }

        window.history.replaceState({}, '', replacedURL);

        // Only track this again on first post onwards
        if (i > 1 && this.trackedPosts.indexOf(this.activePost) === -1) {
          this.trackedPosts.push(this.activePost);
          this.refreshThirdPartyTrackers(postData, i);
        }

        this.setActiveSocial(post);
      }
    }
    return false;
  }

  refreshSocialEmbeds() {
    if (canUseDOM) {
      if (!window.instgrm) {
        scriptjs('//platform.instagram.com/en_US/embeds.js', () => {
          window.instgrm.Embeds.process();
        });
      } else {
        window.instgrm.Embeds.process();
      }

      if (!window.twttr) {
        scriptjs('//platform.twitter.com/widgets.js', () => {
          window.twttr.widgets.load();
        });
      } else {
        window.twttr.widgets.load();
        scriptjs('//view.ceros.com/scroll-proxy.min.js');
        scriptjs(
          '//creative-services.ceros.com/customer-success/varying-embed-tag-generator/embedded-variant-switcher-v3.min.js'
        );
      }
    }
  }

  refreshThirdPartyTrackers(postData, pageNumber) {
    const { config } = this.props;
    const currentActivePostState = {
      context: {
        site: get(config, 'site'),
        type: 'post',
        postData
      },
      config
    };
    document.title = get(postData, 'title');
    trackThirdPartyJS(currentActivePostState, pageNumber);
  }

  generateAdData(postData) {
    const { config } = this.props;
    const site = get(config, 'site') || 'fastcompany';
    const adData = buildPostAdModel(adsConfig, site, postData, 'postPage');

    if (canUseDOM) {
      // Update the data layer
      extend(window.digitalData.page.pageInfo, {
        adPath: `/4160/mv.fc/${adData.model.adzone}`
      });
    }

    return extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') || {} },
      { definitions: get(adData, 'config.definitions') || {} },
      { model: adData.model || {} }
    );
  }

  renderDianomiOrMoreStories(combinedAdModel) {
    const { config, postAfterbodyRecircModuleType } = this.props;
    const initialPageLoad = get(config, 'initialPageLoad');
    const moduleType = get(postAfterbodyRecircModuleType, 'type');
    // const moduleType = 'dianomi';

    // If user is international, display dianomi regardless of options
    if (!initialPageLoad && canUseDOM) {
      if (Cookies.get('fc_rev_content')) {
        return (
          <Dianomi
            initialPageLoad={initialPageLoad}
            site={get(config, 'site')}
            postNativeAd={this.props.postNativeAd}
            config={config}
          />
        );
      }
    }

    // If type is more stories in manage, display that
    if (moduleType === 'More Stories') {
      return this.renderMoreStories(combinedAdModel);
    }

    // Default to dianomi
    return (
      <Dianomi
        initialPageLoad={initialPageLoad}
        site={get(config, 'site')}
        postNativeAd={this.props.postNativeAd}
        config={config}
      />
    );
  }

  renderVideo() {
    const { postVideo, config, post } = this.props;
    const feedID = get(post, 'posterVideo.feedId');

    // Do not display video module when on a video post
    if (feedID) {
      return '';
    }

    if (!isEmpty(postVideo)) {
      const currentSite = get(this.props, 'config.site');
      get(config, 'site');
      return (
        <VideoModule
          config={config}
          data={postVideo}
          playerid="MyQ2uJQ0"
          pos="newmultiplayer"
          stories={this.props.postVideo.playlist}
          currentSite={currentSite}
          isPost={true}
          readTime={get(post, 'readTime')}
        />
      );
    }

    return null;
  }

  renderMoreStories(combinedAdModel) {
    let postMoreStories = get(this.props, 'postMoreStories.posts');

    const { postAfterbodyRecircModuleType, config } = this.props;
    const postAfterbodyRecircModuleTiles = get(
      postAfterbodyRecircModuleType,
      'tiles'
    );
    const postAfterbodyRecircModuleTilesAdzoneMetadata = get(
      postAfterbodyRecircModuleType,
      'tileAdzone',
      ''
    );

    const postAfterbodyRecircModuleTilesAdzoneMetadataSplit = postAfterbodyRecircModuleTilesAdzoneMetadata.split(
      ','
    );
    let slugData;

    if (postAfterbodyRecircModuleTiles) {
      const currentDate = new Date();
      const isEvenDay = toNumber(currentDate.getDate()) % 2 === 0;

      postMoreStories = postAfterbodyRecircModuleTiles.map((story, idx) =>
        Object.assign(story, {
          id: `12345-${idx}`,
          currentSite: get(config, 'site'),
          events: false,
          assetSizes: imageSizesLookup.bigFirstMobile,
          noLazy: true,
          isSponsoredTile: isEvenDay,
          external: true
        })
      );

      slugData = {
        name: get(postAfterbodyRecircModuleTilesAdzoneMetadataSplit, '[1]'),
        tagLine: get(postAfterbodyRecircModuleTilesAdzoneMetadataSplit, '[2]')
      };
    }

    if (
      postMoreStories &&
      get(postMoreStories, 'length') &&
      get(this.props, 'postFinite.length') &&
      canUseDOM
    ) {
      return (
        <Fragment>
          {postAfterbodyRecircModuleTilesAdzoneMetadata ? (
            <Fragment>
              <Ad
                {...combinedAdModel}
                pos="btf"
                noBorder={true}
                slug={false}
                adzoneOverride={get(
                  postAfterbodyRecircModuleTilesAdzoneMetadataSplit,
                  '[0]'
                )}
                name="nativecollectionmodule_01"
              />
              <MoreStories
                metadata={postMoreStories}
                isPost={true}
                slugData={slugData}
                config={this.props.config}
                hasSponsoredContentLabel={true}
                noBottomBorder={true}
              />
            </Fragment>
          ) : (
            <MoreStories
              metadata={postMoreStories}
              isPost={true}
              config={this.props.config}
            />
          )}
        </Fragment>
      );
    }

    return null;
  }

  renderPostFinite(postFinite, related, sticky, config, playerIds) {
    if (!get(postFinite, 'length')) {
      return null;
    }

    return postFinite.map((postData, index) => {
      if (postData.isVideoPermalink || get(postData, 'posterVideo.feedId')) {
        if (!playerIds[index + 1]) {
          set(postData, 'playerScriptId', 'G2hQKLvX');
        } else {
          set(postData, 'playerScriptId', playerIds[index + 1]);
        }
      }
      return (
        <Insert
          config={config}
          tags={get(postData, 'tags')}
          postData={postData}
          insert={true}
          pageNum={index + 1}
          related={related}
          combinedAdModel={this.generateAdData(postData)}
          videoAdData={get(this.props.postpage, 'ads.model', {})}
          updateCorrelator={true}
          live={false}
          isDesktop={sticky}
        />
      );
    });
  }

  render() {
    const { config, statusCode, post, related, postpage } = this.props;
    const abGroupCookie = Cookies.get('abgroup');
    let defaultABGroup = 0;
    let shouldRenderVideoModule = true;
    let shouldRenderDianomi = true;

    if (abGroupCookie) {
      defaultABGroup = parseInt(abGroupCookie, 10);
    }

    // Groups 1-2: Hide all
    // Groups 3-20: No video/carousel
    //                       No newsletter signup
    //                       Only two Parsley "you might also like" links
    //                       Keep Dianomi

    if (
      (defaultABGroup >= 1 && defaultABGroup <= 2) ||
      isAdvertorial(get(post, 'tags'))
    ) {
      shouldRenderVideoModule = false;
      shouldRenderDianomi = false;
    }
    if (defaultABGroup >= 3 && defaultABGroup <= 20) {
      shouldRenderVideoModule = false;
    }

    const stickyToasterVideoDOM = this.state.stickToasterVideo ? (
      <FloatingPlayer
        floatingClassName="floating-player--is-floating"
        position="bottom-left-toaster"
        isFloating={this.state.stickToasterVideo}
      >
        <ToasterVideoModule
          config={this.props.config}
          unStick={() => {
            this.setState({
              stickToasterVideo: false,
              ignoreToasterVideo: true
            });
          }}
          type="toaster"
          playerid="2fyG0pBE"
          playlistId="PTvgvDm1"
          pos="toaster"
        />
      </FloatingPlayer>
    ) : (
      ''
    );
    if (postpage.isLoading && statusCode === 200) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    if (postpage.error || isEmpty(post)) {
      return (
        <section className="post-page">
          <article className="post__main--error-pg">
            <NotFound
              statusCode={statusCode}
              message={
                statusCode === 403 || statusCode === 401
                  ? 'Post is not available.'
                  : undefined
              }
            />
          </article>
        </section>
      );
    }

    const sticky = this.stickySidebar;

    const combinedAdModel = this.generateAdData(post);
    if (post.isVideoPermalink || get(post, 'posterVideo.feedId')) {
      set(post, 'playerScriptId', this.playerScriptIds[0]);
    }

    return (
      <section className="post-page">
        {this.state.displayingAdhesiveUnit && (
          <div className="adhesive adhesive-banner">
            <Ad
              {...combinedAdModel}
              noBorder={true}
              slug={false}
              collapseEmptyDiv={true}
              name="mobile_adhesive"
            />
          </div>
        )}
        <PostsContainer
          config={this.props.config}
          posts={[post]}
          combinedAdModel={combinedAdModel}
          pageNum={0}
          related={related}
          isDesktop={sticky}
          isFirstPost={true}
          videoAdData={get(postpage, 'ads.model', {})}
          live={this.live}
        />

        {stickyToasterVideoDOM}
        {this.live ? (
          <div className="post__article-top-ad-wrapper">
            <Ad
              {...combinedAdModel}
              name="flexiblebillboard"
              region="articlebottom"
              pageNum={1}
            />
            <Ad
              {...combinedAdModel}
              name="mobileleaderboard"
              region="articlebottom"
              pageNum={1}
            />
          </div>
        ) : (
          <div>
            {shouldRenderDianomi
              ? this.renderDianomiOrMoreStories(combinedAdModel)
              : ''}
            {shouldRenderVideoModule ? this.renderVideo() : ''}
            {this.renderPostFinite(
              this.state.finitePosts,
              related,
              sticky,
              config,
              this.playerScriptIds
            )}
          </div>
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    adsLoaded: get(state, 'ads.data'),
    statusCode: get(state, 'status.code'),
    config: state.config,
    postpage: state.postpage,
    post: get(state, 'post.data.post', {}),
    related: get(state, 'post.data.related', []),
    postVideo: get(state, 'postVideo.data', {
      feedid: '',
      playlist: [],
      title: ''
    }),
    postAfterbodyRecircModuleType: get(
      state,
      'postAfterbodyRecircModuleType.data'
    ),
    postMoreStories: get(state, 'postMoreStories.data'),
    postFinite: get(state, 'postFinite.data.posts', []),
    postNativeAd: get(state, 'postNativeAd.data', {}),
    nativeInfiniteScrollPost: get(
      state,
      'postNativeAd.data.infiniteScroll.posts',
      []
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchInfiniteScrollUrlChange() {
      dispatch(infiniteScrollUrlChange());
    },

    dispatchPostFinite(id, advertorialTag, config) {
      return asyncPostFiniteActions(dispatch, id, advertorialTag, config);
    },

    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

PostPage.defaultProps = {
  postAfterbodyRecircModuleType: {
    type: 'More Stories'
  }
};

PostPage.propTypes = {
  statusCode: PropTypes.number.isRequired,
  config: PropTypes.shape({}).isRequired,
  dispatchInfiniteScrollUrlChange: PropTypes.func.isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired,
  dispatchPostFinite: PropTypes.func.isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  post: PropTypes.shape({}).isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postpage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    postScrollDepth: PropTypes.number
  }).isRequired,
  postVideo: PropTypes.shape({
    feedid: PropTypes.string,
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    title: PropTypes.string
  }).isRequired,
  postFinite: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postNativeAd: PropTypes.shape({}).isRequired,
  postAfterbodyRecircModuleType: PropTypes.shape({
    type: PropTypes.string
  })
};

export default connect(mapStateToProps, mapDispatchToProps)(PostPage);
